import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-resource-not-found',
  templateUrl: './resource-not-found.component.html',
  styleUrl: './resource-not-found.component.scss'
})
export class ResourceNotFoundComponent {

  constructor(public router: Router){}

  goHomePage(){
    this.router.navigate(['']);
  }
}
